import { business } from '@icabbi/api-gateway-client';
import apiInstance, { apiCall } from '@/helpers/apiInstance';

const defaultState = {
  businessReportingServiceConnector: null,
};

const getters = {
  // eslint-disable-next-line no-shadow
  businessReportingServiceConnector: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (!state.businessReportingServiceConnector) {
      state.businessReportingServiceConnector = apiInstance({ dispatch, getters: rootGetters, Connector: business.BusinessReportingServiceConnector });
    }
    return state.businessReportingServiceConnector;
  },
};

const actions = {
  generateReport: apiCall(async (context, {
    corporationId, startDate, endDate, filename,
  }) => {
    const lang = context.rootGetters['language/selectedLanguage'];
    return context.getters.businessReportingServiceConnector(context).generateReport({
      corporationId, startDate, endDate, filename, lang,
    });
  }),

  generateBookingReport: apiCall(async (context, {
    filter, page, maxPerPage, corporationId, startDate, endDate, sort,
  }) => context.getters.businessReportingServiceConnector(context).getReportBookings({
    filter, page, maxPerPage, corporationId, startDate, endDate, sort,
  })),
};

const mutations = {};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
